import {
  Space,
  Dropdown,
  message,
  DatePicker,
  Modal,
  Tag
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  MenuOutlined,
  HistoryOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import moment from "moment";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import dayjs from "dayjs";
import HolidayCalendarModal from "./component/HolidayCalendarModal";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [year, setYear] = useState(moment().format('YYYY'))
  const [currentRecord, setCurrentRecord] = useState(null);

  const controllersRef = useRef([])

  const createController = () => {
    const controller = new AbortController()
    controllersRef.current.push(controller)
    return controller
  }

  const cancelAllRequests = () => {
    controllersRef.current.forEach(c => c?.abort())
    controllersRef.current = []
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Edit") || commonFn.btnAuthorityFlag("Delete")) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag("Edit") && {
                key: "edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              },
              commonFn.btnAuthorityFlag("Delete") && {
                key: "delete",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: 'Holiday Name',
      dataIndex: "holidayName",
      titleType: '',
      // isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: 'Holiday Date',
      dataIndex: "holidayDate",
      titleType: '',
      isArrayDate: true,
      // isSorter: false,
    },
    {
      title: 'State Code',
      dataIndex: "stateCode",
      titleType: '',
      // isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: 'Paid Holiday',
      dataIndex: "isPaid",
      titleType: '',
      // isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        const { id } = record
        const isPaidFlag = text == 1;
        const handleClick = () => {
          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {isPaidFlag ? " No" : " Yes"}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            style: {
              top: "40%",
            },
            onOk: async () => {
                const response = await http.get(api.holidayCalendarQuickPaid, {params: {id, isPaid: isPaidFlag ? 2 : 1}});
                if (response?.code === "1") {
                  message.success("Status updated successfully");
                  getTableListFn();
                }
            },
          });
        };
        return (
          <Tag
            color={isPaidFlag ? "green" : "red"}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            { isPaidFlag ? "Yes" : "No" }
          </Tag>
        );
      },
    },
    {
      title: 'Enabled',
      dataIndex: "enabled",
      titleType: '',
      // isSorter: true,
      sortterMultiple: 3,
      render: (text) => {
        const isEnabled = text == 1;
        return (
          <Tag
            color={isEnabled ? "green" : "red"}
          >
            { isEnabled ? "Yes" : "No" }
          </Tag>
        )
      },
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState({});
  const [tableLoading, setTableLoading] = useState(false);

  //列表
  const getTableListFn = async () => {
    const controller = createController()
    setTableLoading(true);
    const params = {
      year
    };
    const response = await http.get(api.holidayCalendarShow, { params, signal: controller.signal });
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    setTableList(response.data || {});
    setTableLoading(false);
  };

  // 新增修改
  const HolidayCalendarRef = useRef(null);
  
  const newFn = () => {
    HolidayCalendarRef.current.openModal({
      type: 'add',
      modalName: 'New Holiday Calendar',
    })
  }

  const customModalRef = useRef(null);

  const handleMenuClick = async (item, record) => {
    const { key } = item
    setCurrentRecord(record);
    if(['edit'].includes(key)){
      HolidayCalendarRef.current.openModal({
        oldState: record,
        type: 'edit',
        modalName: 'Edit Holiday Calendar',
      })
    }else if(['delete'].includes(key)) {
      customModalRef.current.openModalFn();
    }
  }

  const deleteFn = async () => {
    const response = await http.get(api.holidayCalendarDelete, {
      params: {
        id: currentRecord.id
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn();
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  const initColunmsFn = () => {
    setTableList({})
    setColumns(initColumns);
    cancelAllRequests()
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn();
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn()
  }, [refreshKey, year])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
          <DatePicker defaultValue={dayjs(year, 'YYYY')} onChange={(_, data) => setYear(data)} allowClear={false} picker="year" />
        </div>
      </CustomTableExtend>

      <div style={{height: 'calc(100vh - 250px)' ,overflow: 'auto'}}>
        {
          Object.keys(tableList)?.map((item, index) => {
            return (
              <>
                <div style={{
                  fontFamily: 'OpenSans',
                  fontWeight: 600,
                  color:' #0E172B',
                  fontSize: 16,
                  marginTop: index && 20 ,
                  marginBottom: 20,
                }}>{item}</div>
                <CustomTable
                  refreshKey={index}
                  tableLoading={tableLoading}
                  rowKey="id"
                  columns={columns}
                  tableList={tableList[item]}
                  pagination={false}
                  tableScrollYAll={undefined}
                />
              </>
            )
          })
        }
      </div>
      
      <HolidayCalendarModal
        ref={HolidayCalendarRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: "holiday calendar",
          onOkFn: deleteFn,
        }}
      />
    </div>
  );
});
export default MainTable;
